import React from 'react'
import { Dropdown } from 'semantic-ui-react'

/**
 *
 * @param {object} props
 * @param {object} props.defaultBrand
 * @param {Array} props.brandOptions
 * @param {(_, event) => void} props.onBrandChange
 */
export default function SurveyBrandDropdown({ defaultBrand, brandOptions, onBrandChange }) {
  return (
    <Dropdown
      defaultValue={defaultBrand.value}
      selection
      options={brandOptions}
      onChange={onBrandChange}
      search
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyBrandDropdown/index.js